const getUsuario = (state) => {
  return state.usuario
}

export default {
  getUsuario
}



// WEBPACK FOOTER //
// ./src/features/auth/store/getters.js